import { autoinject } from "aurelia-framework";

import { FetchClient } from "../common/fetch-client";
import { IGetSupplyByName, IGetSupplyByNameQuery } from "../resources-vue/vue-interfaces/i-get-supply";
import { Supply } from "../resources-vue/vue-models/supply";

@autoinject()
export class SupplyService {
    private _httpClient: FetchClient;
    private _baseUrl: string = "/api/v1/supplies";

    public constructor(httpClient: FetchClient) {
        this._httpClient = httpClient;
    }

    public async getSuppliesByName(query: IGetSupplyByNameQuery) {
        return await this._httpClient
            .build(`${this._baseUrl}/search-by-name`)
            .useQueryString(query)
            .fetch<IGetSupplyByName[]>();
    }
}
